import { Directive } from '@angular/core';

@Directive({
  selector: '[appOpenMenu]'
})
export class OpenMenuDirective {

  constructor() { }

}
